const state = {
  place: null,
  scans_left: null,
}
const getters = {
  hasPlace: state => !!state.place,
  statePlace: state => state.place,
  stateScansLeft: state => state.scans_left,
}
const mutations = {
  setPlace (state, place) {
    state.place = place
  },
  setScansLeft (state, scans_left) {
    state.scans_left = scans_left
  },
  clearPlace(state) {
    Object.assign(state, {
      place: null,
      scans_left: null,
    })
  }
}
const actions = {
}
export default {
  state,
  getters,
  mutations,
  actions
}
